import { LoadingSpinner } from "./Spinner";
import { LoadingBubbles } from "./Bubbles";
import { LoadingSkeleton } from "./Skeleton";
import { withDisplayName } from "../../types";

export default {
  Spinner: withDisplayName(LoadingSpinner, "Loading.Spinner"),
  Bubbles: withDisplayName(LoadingBubbles, "Loading.Bubbles"),
  Skeleton: withDisplayName(LoadingSkeleton, "Loading.Skeleton")
};

export * from "./types";
